import { render, staticRenderFns } from "./ProfileChangePIN.vue?vue&type=template&id=71e1a291"
import script from "./ProfileChangePIN.vue?vue&type=script&lang=js"
export * from "./ProfileChangePIN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports